import { FC, useState } from 'react';
import { Col, Form, Input, Modal, Row } from 'antd';
import AlertC from '../../components/Alert/Alert';
import { Select } from 'antd';
import { update } from "../../services/firestore";
import { Timestamp } from "firebase/firestore";
import { states } from "../../utils/constants";

const { Option } = Select;

interface RafflesModalProps {
  open: boolean,
  onClose: Function,
  idTicket: string | undefined;
}

interface FormModal {
  buyer: string,
  phone: number | string,
  state: string | undefined;
}

const TicketsModalBuy: FC<RafflesModalProps> = ({ open, idTicket = "", onClose }) => {
  const [formModal, setFormModal] = useState<FormModal>({ buyer: "", phone: "", state: "" });
  const [saving, setSaving] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [form] = Form.useForm();

  if (!idTicket) return null;

  const onAccept = async () => {
    if (saving) return;

    //agregar atomicidad

    try {
      setSaving(true);

      const dataBuyer = { status: "Pagado", reservationDate: Timestamp.now(), ...formModal };
      await update("tickets", idTicket, dataBuyer);

      onClose(true, dataBuyer);
      setMessage("Boleto comprado con exito!");
      setTimeout(() => {
        setMessage("");
      }, 4000);
    } catch (error) {
      console.log(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Modal
        title="Comprar boleto"
        okButtonProps={{
          style: { backgroundColor: "orangered" }
        }}
        open={open}
        cancelText="Cancelar"
        okText="Comprar"
        onCancel={() => onClose(false)}
        onOk={() =>
          form.validateFields()
            .then(async () => {
              await onAccept();
            })
        }
        confirmLoading={saving}
      >
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Nombre"
                name="name"
                rules={[{ required: true, message: 'Favor de escribir el Nombre' }]}
              >
                <Input value={formModal.buyer} onChange={(e) => setFormModal({ ...formModal, buyer: e.target.value })} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Teléfono"
                name="phone"
                rules={[{ required: true, len: 10, message: 'Favor de escribir el Teléfono de 10 digitos' }]}
              >
                <Input
                  type="number"
                  value={formModal.phone}
                  onChange={(e) => setFormModal({ ...formModal, phone: e.target.value })}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Estado"
                name="state"
                rules={[{ required: true, message: 'Favor de seleccioanr el Estado' }]}
              >
                <Select onChange={(value) => setFormModal({ ...formModal, state: value?.toString() })}>
                  {
                    states.map((state) => (
                      <Option value={state} key={state}>{state}</Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal >
      <AlertC
        open={Boolean(message)}
        onClose={() => setMessage("")}
        severity="success"
        message={message}
      />
    </>
  );
};

export default TicketsModalBuy;
